import { OpLocation } from './op-location'
import { OpDevice } from './op-device'
import { OpMeter } from './op-meter'

import { Enums, OpChangeState } from '../common/enums'

import { ConvertHelper } from '../../helpers/convert-helper';

import { IOpChangeState, IJsonSerializable, IReferenceType, IOpObject } from '../util/interfaces'
import { OpDataList } from '../util';
import { OpData } from './op-data';

export class OpLocationEquipment implements IOpChangeState, IJsonSerializable, IReferenceType, IOpObject {

    // Properties

    public idLocationEquipment: number
    public idLocation: number
    public idMeter: number
    public serialNbr: number
    public startTime: Date = null
    public endTime: Date = null

    // Properties End


    // Navigation Properties

    private _location: OpLocation
    public get location(): OpLocation {
        return this._location
    }
    public set location(value: OpLocation) {
        this._location = value
        this.idLocation = value ? value.idLocation : null
    }

    private _device: OpDevice
    public get device(): OpDevice {
        return this._device
    }
    public set device(value: OpDevice) {
        this._device = value
        this.serialNbr = value ? value.serialNbr : null
    }

    private _meter: OpMeter
    public get meter(): OpMeter {
        return this._meter
    }

    public set meter(value: OpMeter) {
        this._meter = value
        this.idMeter = value ? value.idMeter : null
    }

    // Navigation Properties End


    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // IOpChangeState Implementation End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idLocationEquipment = opObj.ID_LOCATION_EQUIPMENT
            this.idLocation = opObj.ID_LOCATION
            this.serialNbr = opObj.SERIAL_NBR
            this.idMeter = opObj.ID_METER

            if (opObj.START_TIME) {
                this.startTime = ConvertHelper.stringToDate(opObj.START_TIME)
            }

            if (opObj.END_TIME) {
                this.endTime = ConvertHelper.stringToDate(opObj.END_TIME)
            }

            if (opObj._Location) {
                this.location = new OpLocation(opObj._Location)
            }

            if (opObj._Device) {
                this.device = new OpDevice(opObj._Device)
            }

            if (opObj._Meter) {
                this.meter = new OpMeter(opObj._Meter)
            }

            this.dynamicValues = opObj.dynamicValues
            this.opState = opObj.OpState
        } else {
            this.idLocationEquipment = 0
            this.opState = OpChangeState.New
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_LOCATION_EQUIPMENT: this.idLocationEquipment,
            ID_LOCATION: this.idLocation,
            SERIAL_NBR: this.serialNbr,
            ID_METER: this.idMeter,

            START_TIME: this.startTime ? ConvertHelper.dateToString(this.startTime, { netFormat: true }) : null,
            END_TIME: this.endTime ? ConvertHelper.dateToString(this.endTime, { netFormat: true }) : null,

            _Device: this.device ? this.device.toJSON() : null,

            OpState: this.opState
        }
    }

    // IJsonSerializable Implementation End

    // #region IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdLocationEquipment
    }
    public getReferenceKey(): number {
        return this.idLocationEquipment
    }
    public getReferenceValue(): any {
        return this
    }

    // #endregion

    // #region IOpObject Implementation

    public get idObject(): any {
        return this.idLocationEquipment
    }

    public set idObject(idObject: any) {
        this.idLocationEquipment = idObject
    }

    public dataList: OpDataList<OpData> = new OpDataList<OpData>()
    public customFormatString: string

    public dynamicValues: { Key: string, Value: any }[]
    
    // #endregion

    public toString(): string {
        return "LocationEquipment [" + this.idLocationEquipment + "]"
    }
}